<!--
    Component Name: SingleMembershipEditor
    Summary:
    Properties:
-->
<template>
    <div class="MultiMembershipEditor">
        <div v-if="CheckPermission(ViewPermissionRequirement)">
            <b-container>
                <b-row style="overflow-x:auto;">
                    <b-col cols="11">
                        <div v-if="SaveOriginalArray.length > 10">
                            <div v-if="ToggleNumberOfRecordsShownValue == false">
                                <font-awesome-icon :icon="['fa', 'toggle-off']" v-on:click="ToggleNumberOfRecordsShown()" class="pointer" />
                            </div>
                            <div v-else>
                                <font-awesome-icon :icon="['fa', 'toggle-on']" v-on:click="ToggleNumberOfRecordsShown()" class="pointer" />
                            </div>
                        </div>
                        <vuetable :fields="Fields"
                                  :data="FieldData"
                                  pagination-path=""
                                  :api-mode="false"
                                  class="vue-datatable"
                                  :row-class="onRowClass">
                        </vuetable>
                    </b-col>
                    <b-col cols="1">
                        <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                            <b-row v-if="TableState == 'NoRecords'">
                                <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                            </b-row>
                            <b-row v-if="TableState == 'OneOpen'">
                                <font-awesome-icon :icon="['fas', 'exchange-alt']" v-on:click="ShowTransferRecord()" class="pointer olive-green-text" />
                            </b-row>
                            <b-row v-if="TableState == 'OneOpen'">
                                <font-awesome-icon :icon="['fas', 'trash-alt']" v-on:click="ShowDeleteRecord()" class="pointer red" />
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <!--ADD NEW RECORD MODAL-->
            <b-modal ref="add-modal" :title="AddRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="AddRecord">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>{{ SelectLabel }}</label>
                                    <select class="form-control" v-model="NewRecordValue" required>
                                        <option v-for="option in NewRecordOptions" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--TRANSFER RECORD MODAL-->
            <b-modal ref="transfer-modal" :title="TransferRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="TransferRecord">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>{{ SelectLabel }}</label>
                                    <select class="form-control" v-model="NewRecordValue" required>
                                        <option v-for="option in NewRecordOptions" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Effective Date:</label>
                                    <flat-pickr v-model="TransferEffectiveDate" class="form-control" ref="showfocus" required :config="DateConfig"></flat-pickr>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelTransferRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--DELETE CURRENT RECORD MODAL-->
            <b-modal ref="delete-modal" :title="DeleteRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="DeleteRecord">
                        <b-row>
                            <b-col>
                                <p>{{ DeleteRecordModalText }}</p>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelDeleteRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="danger" type="submit">
                                    DELETE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </div>
        <div v-else>
            PRIVATE
        </div>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);

    import { faToggleOff } from '@fortawesome/free-solid-svg-icons';
    library.add(faToggleOff);
    import { faToggleOn } from '@fortawesome/free-solid-svg-icons';
    library.add(faToggleOn);
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            
            "Fields",
            "FieldData",
            "SelectLabel",
            "OptionsType",//api,data
            "OptionsMethod",
            "OptionsMethodRecordId",
            "AddRecordMethod",
            "AddRecordRecordPropertyName",
            "AddRecordAdditionalPayload",
            "AddRecordModalTitle",

            "TransferRecordMethod",
            "TransferRecordRecordPropertyName",
            "TransferRecordEffectiveDatePropertyName",
            "TransferRecordAdditionalPayload",
            "TransferRecordModalTitle",

            "DeleteRecordMethod",
            "DeleteRecordRecordPropertyName",
            "DeleteRecordAdditionalPayload",
            "DeleteRecordModalTitle",
            "DeleteRecordModalText",

            "OldValue",
            "OldValueText",
            "PropertyName",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "Options",
            "EditPermission",
            "ViewPermissionRequirement",

            "ChartId"
        ],
        data: function () {
            return {
                ToggleNumberOfRecordsShownValue: false,
                SaveOriginalArray: [],
                NewRecordValue: "",
                NewRecordOptions: {},
                TransferEffectiveDate: "",
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                }
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            //ADD RECORD
            ShowAddRecord() {
                this.NewRecordValue = "";
                this.$MasterAPI.ExecuteRequest("GET", this.OptionsMethod, { Id: this.OptionsMethodRecordId }, this.ShowAddRecordSuccess, () => { }, false);
            },
            ShowAddRecordSuccess(response) {
                 this.$set(vm, "NewRecordOptions", response.data.data);
                 this.$refs['add-modal'].show();
            },
            AddRecord(e) {
                e.preventDefault();
                var vm = this;
                let initialPayload = { Id: this.RecordId, [this.AddRecordRecordPropertyName]: this.NewRecordValue };
                let finalPayload = { ...initialPayload, ...this.AddRecordAdditionalPayload };
                this.$MasterAPI.ExecuteRequest("POST", this.AddRecordMethod, finalPayload, this.AddRecordSuccess, () => { }, true);

            },
            AddRecordSuccess(response) {
                this.$refs['add-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelAddRecord() {
                this.$refs['add-modal'].hide();
            },
            //TRANSFER RECORD
            ShowTransferRecord() {
                this.NewRecordValue = "";
                this.TransferEffectiveDate = "";
                this.$MasterAPI.ExecuteRequest("GET", this.OptionsMethod, { Id: this.OptionsMethodRecordId }, this.ShowTransferRecordSuccess, () => { }, false);
            },
            ShowTransferRecordSuccess(response) {
                this.$set(this, "NewRecordOptions", response.data.data);
                this.$refs['transfer-modal'].show();
            },
            TransferRecord(e) {
                e.preventDefault();
                //var vm = this;
                let initialPayload = { Id: this.RecordId, [this.TransferRecordEffectiveDatePropertyName]:this.TransferEffectiveDate, [this.TransferRecordRecordPropertyName]: this.NewRecordValue };
                let finalPayload = { ...initialPayload, ...this.TransferRecordAdditionalPayload };
                this.$MasterAPI.ExecuteRequest("POST", this.TransferRecordMethod, finalPayload, this.TransferRecordSuccess, () => { }, true);
            },
            TransferRecordSuccess(response) {
                this.$refs['transfer-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelTransferRecord() {
                this.$refs['transfer-modal'].hide();
            },
            //DELETE RECORD
            ShowDeleteRecord() {
                this.$refs['delete-modal'].show();
            },
            DeleteRecord(e) {
                e.preventDefault();
                //var vm = this;
                let initialPayload = { Id: this.RecordId };
                let finalPayload = { ...initialPayload, ...this.DeleteRecordAdditionalPayload };
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteRecordMethod, finalPayload, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.$refs['delete-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelDeleteRecord() {
                this.$refs['delete-modal'].hide();
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultValue='') {
              return (value == null)
                ? defaultValue
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleNumberOfRecordsShown() {
                this.ToggleNumberOfRecordsShownValue = !this.ToggleNumberOfRecordsShownValue;
                if (this.ToggleNumberOfRecordsShownValue) {
                    this.FieldData = this.FieldData.slice(0, 10);
                }
                else {
                    this.FieldData = this.SaveOriginalArray;
                }
            }
        },
        components: {
            Vuetable,
            flatPickr
        },
        mounted() {
            this.SaveOriginalArray = this.FieldData;
            this.ToggleNumberOfRecordsShown();
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
            TableState: function () {
                if (this.FieldData.length == 0) {
                    return "NoRecords";
                }
                else if (this.FieldData.filter(datalist => datalist.EndDate == null).length == 0) {
                    return "AllClosed";
                } else {
                    return "OneOpen";
                }
                 
            }
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>